import * as singleSpa from "single-spa";

import globalRouter from "./global-router";

import dialerApp from "./apps/dialer";
import callcenterApp from "./apps/callcenter";
import enswitchApp from "./apps/pbx";
import crmApp from "./apps/crm";
import {ToolbarLoginApp} from "./apps/app-login";

function regApp(app, routerName) {
	singleSpa.registerApplication(app.name, async() => {
		await app.load();
		return app.getAppConfig();
	}, globalRouter(routerName));
}

export function bootstrapSingleSPA() {
	regApp(dialerApp, "DIALER");
	regApp(callcenterApp, "CALLCENTER");
	regApp(enswitchApp, "PBX");
	regApp(crmApp, "CRM");
	regApp(ToolbarLoginApp, "AUTH-TOOLBAR");

	singleSpa.start();
}
